<script>
export default {
    name: 'QuoteIndex',
    created() {
        this.$router.replace('/quote/model')
    }
}
</script>